import { TComment } from "../comment/comment.types";

export const createInitialRepliesPageData = (comment: TComment) => {
    if (comment.replies?.replies) {
        return { pageParams: [undefined], pages: [{ comments: comment.replies.replies, commentsCount: comment.replies.repliesCount }] };
    }

    return undefined;
};

export type TCommentsPaginatedDataType = ReturnType<typeof createInitialRepliesPageData>;
